import { now, user } from 'src/StateObserver';
import { GCInstant as platform } from 'src/lib/gcinstant';
import { isPromoReady } from 'src/replicant/promo/promo.getters';
import { config as promoConfig } from 'src/replicant/promo/promo.ruleset';
import { isNativePromoAvailable } from 'src/game/native/native.util';

export function isHomeShortcutEnabled() {
  return platform.canCreateShortcut;
}

export function isHomeShortcutAvailable() {
  if (!isHomeShortcutEnabled()) return false;

  // Do not show home shortcut promo when native promo is available (#9810)
  if (isNativePromoAvailable()) return false;

  // Feature remains available while launch reward is claimable
  return isPromoReady(user(), 'homeShortcutLaunch', now());
}

export function getHomeShortcutStepIndex() {
  // Return the first step while the add reward is not yet claimed
  return isPromoReady(user(), 'homeShortcutAdd', now()) ? 0 : 1;
}

export function getHomeShortcutGemsReward(type: 'add' | 'launch'): number {
  if (type === 'add') {
    return promoConfig.homeShortcutAdd?.getRewards?.(user(), now())?.gems ?? 0;
  }
  return promoConfig.homeShortcutLaunch?.getRewards?.(user(), now())?.gems ?? 0;
}
